<template>
  <section>
    <div v-if="isLoading" class="loading-area">
      <LoadingBox :isLoading="isLoading" />
    </div>    

    <div v-if="!isLoading">
      <VideoDetailsContainer>
        <CourseVideoPlaceholder
          v-if="isPlaceholderVisible"
        />

        <CourseVideoPlayer
          :course-class-id="courseModuleClass.id"
          :video-id="courseModuleClass.video_code"
          :provider="courseModuleClass.video_provider"
          v-show="!isUpNextVisible && !isPlayerStopped && !isPlaceholderVisible"
          ref="player"
        />

        <CourseVideoPlayerPreviousNext
          v-if="isUpNextVisible"
          @ended="isUpNextVisible = false"
        />
      </VideoDetailsContainer>

      <CourseDetails />

      <CourseContent />
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import CourseVideoPlayer from "@/components/course/CourseVideoPlayer";
import VideoDetailsContainer from "@/components/layout/containers/VideoDetailsContainer";
import LoadingBox from "@/components/layout/LoadingBox";
import CourseDetails from "@/components/course/CourseDetails";
import CourseContent from "@/components/course/CourseContent";
import CourseVideoPlayerPreviousNext from "@/components/course/CourseVideoPlayerPreviousNext";
import CourseVideoPlaceholder from '@/components/course/video-placeholder/CourseVideoPlaceholder'

export default {
  components: {
    CourseVideoPlayer,
    VideoDetailsContainer,
    LoadingBox,
    CourseDetails,
    CourseContent,
    CourseVideoPlayerPreviousNext,
    CourseVideoPlaceholder,
  },

  data: () => ({
    isLoading: true,
    isUpNextEnded: false,
    isLatestWatchHandled: false,
    isEnded: false,
    isUpNextVisible: false,
  }),

  metaInfo() {
    const title = this.course.name ? `Curso ${this.course.name} | CyberClass` : null;

    return {
      title: title,
      meta: [
        {
          property: "description",
          content: `Curso ${this.course.name} - ${this.course.description} | CyberClass`,
        },
      ],
    };
  },

  beforeMount() {
    console.log('url', `${process.env.VUE_APP_V2_APP_URL}/curso/${this.course.id}-${this.course.slug}`)
  },

  async mounted() {
    while (true) {
      try {
        await this.fetchCourse(this.courseId);
        await this.fetchCourseModules(this.courseId);
        await this.fetchCourseMaterials();

        if (this.hasCourseAccess) {
          this.setCourseModuleTabActive(this.courseModule.id);
        }

        this.isLoading = false;
        break;
      } catch (err) {
        break;
        // if (err.status === 404) {
        //   this.$router.replace('/')
        //   break;
        // } else {
        //   console.log(err)
        //   console.log("[ERROR] Error trying to fetch data");
        //   continue;
        // }
      }
    }
  },

  computed: {
    ...mapGetters("user", ["isLogged"]),

    ...mapGetters('player', [
      'isPlayerEnded',
      'isPlayerReady',
      'isPlayerStopped',
      'isPlayerPaused',
      'isPlayerPlaying',
    ]),

    ...mapGetters("course", [
      "course",
      "courseModule",
      "courseClasses",
      "hasCourseAccess",
      "courseModuleClass",
    ]),

    ...mapGetters("subscription", ["subscriptionHasAccess"]),

    isPlaceholderVisible () {
      return this.isPlayerStopped || (this.isPlayerEnded && !this.isUpNextVisible)
    },

    courseId() {
      return parseInt(this.$route.params.id);
    },
  },

  watch: {
    isPlayerEnded (isPlayerEnded) {
      this.isUpNextVisible = isPlayerEnded && !this.courseModuleClass.is_intro
    },

    courseModuleClass(newState) {
      if (Object.keys(newState).length) {
        setTimeout(() => window.document.body.scrollIntoView({ behavior: "smooth" }), 100);

        if (!this.isLatestWatchHandled) {
          this.changeClassToLatestWatched();
          this.isLatestWatchHandled = true;
        }
      }

      this.trackLastClassWatched(newState);      
    },
  },

  methods: {
    ...mapActions("course", [
      "fetchCourse",
      "fetchCourseModules",
      "fetchCourseMaterials",
    ]),

    ...mapMutations("course", ["setCourseModuleClass", "setCourseModuleTabActive"]),

    changeClassToLatestWatched() {
      let latestClassWatched = localStorage.getItem("latest-class-watched");
      latestClassWatched = JSON.parse(latestClassWatched) || {};

      const classCourseId = latestClassWatched[this.courseId];

      if (classCourseId && this.courseModuleClass.id != classCourseId) {
        const courseClass = this.courseClasses.find((i) => i.id == classCourseId);

        this.setCourseModuleClass(courseClass);
      }
    },

    trackLastClassWatched(courseModuleClass) {
      let latestClassWatched = localStorage.getItem("latest-class-watched");
      latestClassWatched = JSON.parse(latestClassWatched) || {};

      latestClassWatched[courseModuleClass.course_id] = courseModuleClass.id;

      localStorage.setItem("latest-class-watched", JSON.stringify(latestClassWatched));
    },
  },
};
</script>

<style scoped lang="scss">
.loading-area {
  position: relative;
  height: 300px;
}

.course-material-box {
  padding: 5rem 0;
}

.class-details {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__course-infos {
    .class-name {
      font-size: 15px;
      line-height: 20px;
      margin-bottom: 5px;
      font-weight: 300;
    }

    .course-name {
      font-size: 22px;
    }

    .author-name {
      font-size: 15px;
      color: rgba(#000, 0.6);
    }
  }

  @media (max-width: 550px) {
    flex-direction: column;
    align-items: flex-start;

    &__options {
      margin-top: 25px;
    }
  }
}
</style>
